import { defineMessages } from "react-intl";

export const messages = defineMessages({
  value: {
    id: "ari.management.table.value",
    defaultMessage: "Value"
  },
  rate: {
    id: "ari.management.table.rate",
    defaultMessage: "Rates"
  },
  availability: {
    id: "ari.management.table.availability",
    defaultMessage: "Avail"
  },
  closed: {
    id: "ari.management.table.closed",
    defaultMessage: "Block"
  },
  closeToArrival: {
    id: "ari.management.table.closeToArrival",
    defaultMessage: "CTA"
  },
  closeToDeparture: {
    id: "ari.management.table.closeToDeparture",
    defaultMessage: "CTD"
  },
  minStay: {
    id: "ari.management.table.minStay",
    defaultMessage: "Min stay"
  },
  maxStay: {
    id: "ari.management.table.maxStay",
    defaultMessage: "Max stay"
  },
  minNotice: {
    id: "ari.management.table.minNotice",
    defaultMessage: "Min adv"
  },
  maxNotice: {
    id: "ari.management.table.maxNotice",
    defaultMessage: "Max adv"
  }
});